export type ModelToResourcePathMap = {
  [modelName: string]: string
}

export function getModelResourcePath(modelName: string): string {
  return modelNameToResourcePathMap[modelName]
}
const modelNameToResourcePathMap: ModelToResourcePathMap = {
  Message: "planning/messages",
  ServiceProviderDate: "administration/service-provider-dates",
  Instruction: "planning/instructions",
  Purchase: "administration/purchases",
  Sale: "administration/sales",
  RentalIntake: "administration/rental-intakes",
  RentalDispense: "administration/rental-dispenses",
  InstructionFeedback: "planning/instruction-feedbacks"
}
